import React from "react";

const CloseModalIcon = ({
  width = "12.669",
  height = "12.669",
  className = "",
}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={width}
        className={className}
        viewBox="0 0 12.669 12.669"
      >
        <path
          id="times-solid"
          d="M8.736,86.335l3.6-3.6a1.132,1.132,0,0,0,0-1.6l-.8-.8a1.132,1.132,0,0,0-1.6,0l-3.6,3.6-3.6-3.6a1.132,1.132,0,0,0-1.6,0l-.8.8a1.132,1.132,0,0,0,0,1.6l3.6,3.6-3.6,3.6a1.132,1.132,0,0,0,0,1.6l.8.8a1.132,1.132,0,0,0,1.6,0l3.6-3.6,3.6,3.6a1.132,1.132,0,0,0,1.6,0l.8-.8a1.132,1.132,0,0,0,0-1.6Z"
          transform="translate(0 -80)"
        />
      </svg>
    </>
  );
};
export default CloseModalIcon;
